// Port of api/fuel/app/classes/insights/collection/init.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'init',
    priority: 10,
    run: function(type, owner, userIndex, detail, filter, vars) {

        this._data.base = []
        this._data.expansions = []
        this._data.versioning = {
            versions: [],
            games: []
        }

        var rows = Util.queryFast('SELECT c.game_id AS g, c.game_version_id AS v, c.collection_expansion AS e FROM collection c WHERE c.collection_own = 1 AND c.user_id IN(' + Util.in(userIndex) + ')')

        for (var i = 0; i < rows.length; i++) {
            var row = rows[i]

            if (row.e) {

                this._data.expansions.push(row.g)

            } else {

                this._data.base.push(row.g)

                if (row.v) {
                    this._data.versioning.versions.push(row.v)
                } else {
                    this._data.versioning.games.push(row.g)
                }

            }
        }

        this._data.base = this._data.base.filter(function(v, i, a) { return a.indexOf(v) === i })
        this._data.expansions = this._data.expansions.filter(function(v, i, a) { return a.indexOf(v) === i })

        if (!this._data.versioning.versions.length) this._data.versioning.versions.push(-1)
        if (!this._data.versioning.games.length) this._data.versioning.games.push(-1)

        return {}

    }
})
